/** 初始化编辑器事件 */
export const INIT_EVENT = 'INIT_EVENT';

/** 初始化编辑器完成事件 */
export const INIT_EVENT_FINISH = 'INIT_EVENT_FINISH';

/** 舞台初始化完成 */
export const INIT_STATE_EVENT = 'INIT_STATE_EVENT';

export const HANDLE_SAVE_PREVIEW_IMAGE = 'handle_save_preview_image';

// 创建画布完成
export const AFTER_CREATE_EVENT = 'AFTER_CREATE_EVENT';

// 菜单滚动
export const MENU_SCROLL_EVENT = 'MENU_SCROLL_EVENT';

/** 关闭插件菜单事件 */
export const PLUGIN_CLOSE_EVENT = 'PLUGIN_CLOSE_EVENT';

/** 打开插件菜单事件 */
export const PLUGIN_OPEN_EVENT = 'PLUGIN_OPEN_EVENT';

/** 切换笔刷标签 */
export const CHANGE_BRUSH_TAG_EVENT = 'change_brush_tag_event';

/** 文件上传 */
export const EVENT_FILES_UPLOAD = 'EVENT_FILES_UPLOAD';

/** 关闭调整面板 */
export const HIDE_PANEL_ADJUST = 'HIDE_PANEL_ADJUST';

/** 更多菜单展开事件 */
export const MORE_COLLAPSE_EVENT = 'MORE_COLLAPSE_EVENT';

/** 手动保存模板 */
export const SAVE_TEMPLATE_EVENT = 'SAVE_TEMPLATE_EVENT';

/** 自动保存模板 */
export const AUTO_SAVE_TEMPLATE_EVENT = 'AUTO_SAVE_TEMPLATE_EVENT';

/** 更新预览 */
export const UPDATE_PREVIEW_EVENT = 'UPDATE_PREVIEW_EVENT';

/** 加载 ai ppt  */
export const LOADING_AI_PPT_EVENT = 'LOADING_AI_PPT_EVENT';

/** 加载 ai ppt 结束 */
export const LOADING_AI_PPT_FINISH = 'LOADING_AI_PPT_FINISH';

/** 创建副本事件 */
export const OPEN_DUPLICATE_EVENT = 'OPEN_DUPLICATE_EVENT';

/** 抠图确认事件 */
export const IMAGE_MATTING_CONFIRM_EVENT = 'IMAGE_MATTING_CONFIRM_EVENT';

/** 抠图取消事件 */
export const IMAGE_MATTING_CANCEL_EVENT = 'IMAGE_MATTING_CANCEL_EVENT';

/** 抠图插件应用事件 */
export const MATTING_PLUGIN_APPLY_EVENT = 'MATTING_PLUGIN_APPLY_EVENT';

/** 抠图插件取消事件 */
export const MATTING_PLUGIN_CANCEL_EVENT = 'MATTING_PLUGIN_CANCEL_EVENT';

/** 跳转到左侧面板-'页面' */
export const REDIRECT_TO_NAVIGATION_EVENT = 'REDIRECT_TO_NAVIGATION_EVENT';

/** 反馈事件 */
export const FEEDBACK_EVENT = 'FEEDBACK_EVENT';

/** 图片编辑器背景离开事件 */
export const ImageEditorBackgroundLeaveEvent = 'ImageEditorBackgroundLeaveEvent';

/** 创建空设计事件 */
export const CREATE_EMPTY_DESIGN_EVENT = 'CREATE_EMPTY_DESIGN_EVENT';

/** 打开图片事件 */
export const CREATE_EMPTY_IMAGE_EVENT = 'CREATE_EMPTY_IMAGE_EVENT';

/** 上传图片事件 */
export const CREATE_IMAGE_UPLOAD_EVENT = 'CREATE_IMAGE_UPLOAD_EVENT';

/** 上传图片错误事件 */
export const CREATE_IMAGE_ERROR_EVENT = 'CREATE_IMAGE_ERROR_EVENT';

/** 图层添加到我的空间事件 */
export const ADD_TO_MY_SPACE_EVENT = 'ADD_TO_MY_SPACE_EVENT';

/** 添加到最近使用事件 */
export const ADD_TO_RECENTLY_EVENT = 'ADD_TO_RECENTLY_EVENT';

/** 重定向到导航器事件 */
export const REDIRECT_TO_EVENT = 'REDIRECT_TO_EVENT';

/** 清除关键词 */
export const CLEAR_KEYWORDS = 'CLEAR_KEYWORDS';

/** 替换模板 */
export const REPLACE_TEMPLATE = 'replace_template';

// 用户信息更新
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

// 价格更新
export const UPDATE_PRICE = 'UPDATE_PRICE';

/** 关闭图片翻译事件 */
export const CLOSE_IMAGE_TRANS_EVENT = 'CLOSE_IMAGE_TRANS_EVENT';

/** 隐藏调色菜单 */
export const HIDE_COLLAPSE_MOG = 'HIDE_COLLAPSE_MOG';

/** 全屏关闭事件 */
export const FULLSCREEN_CLOSE_EVENT = 'FULLSCREEN_CLOSE_EVENT';

/**替换图片事件 */
export const REPLACE_IMAGE_EVENT = 'REPLACE_IMAGE_EVENT';
